export const FAILED_EVENTS_COUNT_DETECTOR_KEY = 'failed_events_count';

const COMPARISON_SYMBOLS = {
  gt: '>',
  gte: '≥',
  lt: '<',
  lte: '≤',
};

const cleanValues = values => values?.map(value => value.trim()).filter(Boolean);

export const buildAlertRuleDetectorConfig = ({
  detectorKey,
  windowPreset,
  failCategoriesExclude,
  failCategoriesInclude,
  capIdPattern,
}) => {
  const config = {
    window_preset: windowPreset,
  };

  if (detectorKey !== FAILED_EVENTS_COUNT_DETECTOR_KEY) {
    return config;
  }

  const cleanedFailCategoriesExclude = cleanValues(failCategoriesExclude);
  const cleanedFailCategoriesInclude = cleanValues(failCategoriesInclude);
  const cleanedCapIdPattern = capIdPattern.trim();

  return {
    ...config,
    fail_categories_exclude: cleanedFailCategoriesExclude?.length > 0 ? cleanedFailCategoriesExclude : undefined,
    fail_categories_include: cleanedFailCategoriesInclude?.length > 0 ? cleanedFailCategoriesInclude : undefined,
    cap_id_pattern: cleanedCapIdPattern || undefined,
  };
};

export const getAlertRuleCondition = rule => {
  const symbol = COMPARISON_SYMBOLS[rule.comparison] || rule.comparison;
  return `${symbol} ${rule.threshold_value}`;
};

export const filterAlertRules = (rules, {
  detectorKeys = [],
  severities = [],
  windowPresets = [],
  statuses = [],
  searchQuery = '',
}) => {
  const normalizedSearchQuery = searchQuery.trim().toLowerCase();

  return rules.filter(rule => {
    if (detectorKeys.length > 0 && !detectorKeys.includes(rule.detector_key)) {
      return false;
    }
    if (severities.length > 0 && !severities.includes(rule.severity)) {
      return false;
    }
    if (windowPresets.length > 0 && !windowPresets.includes(rule.detector_config?.window_preset)) {
      return false;
    }
    if (statuses.length > 0 && !statuses.includes(String(rule.active))) {
      return false;
    }
    if (!normalizedSearchQuery) {
      return true;
    }
    return rule.description?.toLowerCase().includes(normalizedSearchQuery);
  });
};
